import {
    ConsumerUser,
    ConsumerUserAccount, IUserSecurityLog,
    ConsumerUserBalanceLog,
    ConsumerUserDonateLog,
    ConsumerUserFull,
    ConsumerUserLogs,
    IUserTotalDonate
} from '@interfaces/consumer/users';
import { KeyValueSet } from '@interfaces/helpers';
import { PanelTableData } from '@interfaces/panel';
import { ConsumerUserChangeBalanceModel, ConsumerUserChangeRolesModel, ConsumerUserChargeAccountModel } from '@models/consumer/users';
import { PanelTableDataModel } from '@models/panel';
import IService from '../iService';
import {ConsumerPaymentShort} from "@interfaces/consumer/payments";

export default class ConsumerUsersService extends IService {
    async changeConsumerUserBalance(balance: ConsumerUserChangeBalanceModel) {
        return await this.postApi('/api/consumer/users/balance/', balance);
    }

    async changeConsumerUserRoles(roles: ConsumerUserChangeRolesModel) {
        return await this.patchApi('/api/consumer/users/roles/', roles);
    }

    async chargeConsumerUserAccount(model: ConsumerUserChargeAccountModel) {
        return await this.postApi('/api/consumer/users/charge/', model);
    }

    fetchConsumerUsers = async (model: PanelTableDataModel) => {
        return await this.postApi<PanelTableData<ConsumerUser[]>>(`/api/consumer/users/`, model);
    }

    async fetchUser(id: string): Promise<ConsumerUserFull> {
        return await this.getAndThrowApi<ConsumerUserFull>(`/api/consumer/users/${id}/`);
    }

    async fetchUserAccounts(id: string) {
        return await this.getAndThrowApi<ConsumerUserAccount[]>(`/api/consumer/users/${id}/accounts/`)
    }

    async fetchUserPayments(id: string) {
        return await this.getAndThrowApi<ConsumerUserDonateLog[]>(`/api/consumer/users/${id}/payments/`)
    }

    async fetchUserLogs(id: string) {
        return await this.getAndThrowApi<ConsumerUserLogs>(`/api/consumer/logs/users/${id}/`)
    }

    async fetchConsumerRoles() {
        return await this.getAndThrowApi<KeyValueSet<string[]>>('/api/consumer/users/roles/');
    }

    fetchBalanceLogs = async (userId: string, model: PanelTableDataModel) => {
        return await this.postApi<PanelTableData<ConsumerUserBalanceLog[]>>(`/api/consumer/logs/users/${userId}/balance/`, model);
    }

    fetchPaymentLogs = async (userId: string, model: PanelTableDataModel) => {
        return await this.postApi<PanelTableData<ConsumerPaymentShort[]>>(`/api/consumer/users/${userId}/payments/`, model);
    }

    fetchSecurityLogs = async (userId: string, model: PanelTableDataModel) => {
        return await this.postApi<PanelTableData<IUserSecurityLog[]>>(`/api/consumer/logs/users/${userId}/security/`, model);
    }

    fetchUserTotalDonate = async (userId: string) => {
        return await this.getAndThrowApi<IUserTotalDonate>(`/api/consumer/users/${userId}/payments/total/`);
    }
}